import { createAction, props } from '@ngrx/store';
import { Patient } from 'src/models/module-wise/user/patient';

export const paginatePatients = createAction(
  '[ PATIENT ] Paginating'
);

export const loadPatients = createAction(
  '[ PATIENT ] Load Patient',
  props<{ payload: Patient[], totalDocuments: number }>()
);

export const editPatient = createAction(
  '[ PATIENT ] Edit Patient',
  props<{ payload: Patient | { status: string, _id: string } }>()
);

export const removePatients = createAction(
  '[ PATIENT ] Delete Patient',
  props<{ payload: string[] }>()
);

export const removeAllPatients = createAction(
  '[ PATIENT ] Remove All Patient'
);
